"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
(function () {
  const styles = ".Localized-Text {\n  hyphens: auto;\n  overflow-wrap: anywhere;\n  -webkit-hyphens: auto; }\n";
  const fileName = "LocalizedText_LocalizedText";
  const element = document.querySelector("style[data-sass-component='LocalizedText_LocalizedText']");
  if (!element) {
    const styleBlock = document.createElement("style");
    styleBlock.innerHTML = styles;
    styleBlock.setAttribute("data-sass-component", fileName);
    document.head.appendChild(styleBlock);
  } else {
    element.innerHTML = styles;
  }
})();
function LocalizedText(props) {
  const DEFAULT_LANGUAGE_CODE = 'de';
  return /*#__PURE__*/_react.default.createElement("div", {
    lang: props.lang || DEFAULT_LANGUAGE_CODE,
    className: "Localized-Text"
  }, props.children);
}
LocalizedText.protoTypes = {
  lang: _propTypes.default.string.isRequired
};
var _default = exports.default = LocalizedText;